// Delegate — the headless hook moved to `@heidi/tasks/data` (OpenSpec
// `monorepo-tasks-data-core` · D2, ARCFE-945). Cohort B: this file owns the
// app reactions — the error toast (ARCFE-921) and the lifted analytics
// dispatch, replaying the legacy branch: a stateful edit event when the
// optimistic snapshot pinned the previous task, the plain edit event
// otherwise.
import { toast } from '@heidi/design-system/toast';
import {
  useMutateUpdateClinicalTask as useMutateUpdateClinicalTaskCore,
  type UpdateClinicalTaskParams,
} from '@heidi/tasks/data';

import { trackTaskEvent, trackTaskStatefulEvent } from '@/lib/analytics/scribe/task';
import { TaskEventType } from '@/models/analytics/segment-names';

export type { UpdateClinicalTaskParams };

export const useMutateUpdateClinicalTask = () => {
  return useMutateUpdateClinicalTaskCore({
    onUpdateError: () => {
      toast({
        tone: 'destructive',
        title: 'Error updating clinical task',
        description: 'Could not update the clinical task. Please try again.',
      });
    },
    onUpdateSuccess: (data, previousTask) => {
      if (previousTask) {
        trackTaskStatefulEvent({
          taskEventType: TaskEventType.TaskEdited,
          prevTask: previousTask,
          nextTask: data.task,
        });
      } else {
        trackTaskEvent({
          taskEventType: TaskEventType.TaskEdited,
          task: data.task,
        });
      }
    },
  });
};
